// extracted by mini-css-extract-plugin
export var attribution = "_8m-4";
export var authorName = "_8m-5";
export var quote = "_8m-3";
export var testimonial = "_8m-2";
export var trustedBy = "_8m-0";
export var trustedByLabel = "_8m-1";